import QuickApprovalWorkflow from './QuickApprovalWorkflow';
import DirectLink from './DirectLink';
import NewSQLUser from './NewSQLUser';
import NewADUser from './NewADUser';

const Modals = {
  QUICK_APPROVAL_WORKFLOW: QuickApprovalWorkflow,
  DIRECT_LINK: DirectLink,
  NEW_SQL_USER: NewSQLUser,
  NEW_AD_USER: NewADUser,
}

export default Modals;
